import { gatewaySectorWorkFlows } from "../../../../../gateways/gatewaySectorWorkFlows";


export const getScopeOfWork = async ({ scopeOfWorkUid }) => {
  try {
    let uri;

    if (scopeOfWorkUid) {
      uri = `scopes-of-work/${scopeOfWorkUid}`;
    }

    const response = await gatewaySectorWorkFlows.get(uri, {
      // headers: {
        // Authorization: `${token}`,
      // },
    });

    return response.data.data || response.data;
  } catch (error) {
    console.error(`Error getting scope ${scopeOfWorkUid}`, error);
    throw error;
  }
};
